export default "__VITE_ASSET__DzGHHR_X__"